import { Route, Routes } from "react-router-dom";
import Updates from "./list";

export default function UpdatesRequestRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Updates />} />
    </Routes>
  );
}
